/** @format */

/** Same key as AppHeader — TeleCMI WebRTC softphone login token */
export const TELECMI_SP_TOKEN_KEY = 'ibs_telecmi_softphone_token';

export function getTelecmiSoftphoneToken() {
  try {
    const t = sessionStorage.getItem(TELECMI_SP_TOKEN_KEY);
    return t != null && String(t).trim() !== '' ? String(t).trim() : null;
  } catch {
    return null;
  }
}
